export const theme = {
    colors: {
        accentYellow: '#e6e922'
    },
    path: `M 25.000 35.000
           L 36.756 41.180
           L 34.511 28.090
           L 44.021 18.820
           L 30.878 16.910
           L 25.000 5.000
           L 19.122 16.910
           L 5.979 18.820
           L 15.489 28.090
           L 13.244 41.180
           L 25.000 35.000`,
    starSize: '40px',
    starSpacing: '0px'
}



// WEBPACK FOOTER //
// ./src/constants/components/starRating-consts.ts